import { RhombusSplitIcon } from './RhombusSplitIcon';

/**
 * author: Michael Irigoyen
 * id A19BB3EC-ED3D-41C6-9088-ACB372959E01
 * name rhombus-split
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rhombus-split.svg
 * tags
 * - Shape 
 */
export const CollectionIcon = RhombusSplitIcon;
export default CollectionIcon